import { THierarchyItemEditForm } from 'core/model/interfaces/navigation/hierarchy.interface';
import { apiService } from 'core/services';
import type { TSliceExtraReducer } from 'core/store';
import { createAppAsyncThunk } from 'core/store/store.helpers';
import { getErrorFromService } from 'shared/utils/https';
import { notificationService } from 'shared/utils/notification.utils';
import { SLICE_NAMESPACE } from '../../constants';
import { getUnexpectedErrorMessages } from '../../navigation.utils';
import { INavigationState } from '../../types';

export const editNavigationItem = createAppAsyncThunk(
  `${SLICE_NAMESPACE}/editNavigationItem`,
  async ({ data }: { data: THierarchyItemEditForm }) => {
    try {
      await apiService.hierarchy.editHierachyItem(data);
      notificationService.global.success('Mundo editado correctamente.');
    } catch (error) {
      notificationService.drawer.error(getErrorFromService(error, getUnexpectedErrorMessages('items', 'edit')));
      throw error;
    }
  },
);

export const editNavigationItemReducer: TSliceExtraReducer<INavigationState> = builder =>
  builder
    .addCase(editNavigationItem.pending, state => {
      state.form.loading = true;
      state.form.success = false;
    })
    .addCase(editNavigationItem.rejected, state => {
      state.form.loading = false;
      state.form.success = false;
    })
    .addCase(editNavigationItem.fulfilled, state => {
      state.form.loading = false;
      state.form.success = true;
    });
